import React, { forwardRef, ReactNode } from 'react';
import styles from './Checkbox.module.css';

type Types = {
    name: string;
    checked: boolean;
    onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
    label?: string | ReactNode;
    margin?: string;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

type Ref = HTMLInputElement;

export const Checkbox = forwardRef<Ref, Types>(
    ({ name, checked, label, onChange, margin = '10px 0', ...props }, ref) => {
        return (
            <label htmlFor={name} style={{ margin: margin }} className={styles.checkbox}>
                {label}
                <input
                    type="checkbox"
                    id={name}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    ref={ref}
                    {...props}
                />
                <span className={styles.checkmark}></span>
            </label>
        );
    }
);
